import Confirm from "./Confirm";

import ParkingLot from "./ParkingLot";

export default {
  PARKINGLOT: ParkingLot,
  CONFIRM: Confirm,
};
